import PhoneCentersDataView from "./PhoneCentersDataView";
import { IPhoneCenterSearchForm } from "./phoneCenter";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SearchPhoneCenters from "./SearchPhoneCenters";

const defaultFilterData: IPhoneCenterSearchForm = {
  description: ""
}

const PhoneCenters = () => {
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView  title="Αναζήτηση Τηλεφωνικών κέντρων">
        <SearchPhoneCenters />
      </SydFilterView>

      <PhoneCentersDataView />

    </SydFilterProvider>
  )

}
export default PhoneCenters;

